import { useEffect, useState } from "react";
import Loading from "../Components/Loading";
import { Modal, Form, Button } from "react-bootstrap";
import * as api from "../api/api";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { Snackbar, Alert } from "@mui/material";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import checkAuthorization from "../config/checkAuth";

import { useLanguage } from "../Components/Localization/LanguageContext";
import strings from "../Components/Localization/strings";

export default function AdminPhonebook() {
  const { language } = useLanguage();
  const pageTitle = "AdminPhonebook";

  let [newEntryData, setNewEntryData] = useState({
    name: "",
    phone: "",
    lineOfBusiness: "",
    outboundLineName: "",
    position: 1,
  });

  const [snackbarData, setSnackbarData] = useState({});

  let [editingEntryData, setEditingEntryData] = useState({});

  const [itemToDelete, setItemToDelete] = useState({});
  const [phonebookItems, setPhonebookItems] = useState([]);
  const [outboundLines, setOutboundLines] = useState([]);
  const [linesOfBusiness, setLinesOfBusiness] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [modals, setModals] = useState({
    addModal: false,
    editModal: false,
    deleteModal: false,
  });

  const navigate = useNavigate();

  function addNewEntry(event) {
    console.log("called");
    console.log(newEntryData);
    event.preventDefault();
    setLoading(true);

    api
      .postNewPhoneBookItem(newEntryData)
      .then((response) => {
        console.log(response);

        if (response.data.statusCode == 200) {
          setPhonebookItems([...phonebookItems, response.data.object]);
          setModals({ ...modals, addModal: false });
          setNewEntryData({
            name: "",
            phone: "",
            lineOfBusiness: "",
            outboundLineName: "",
            position: 1,
          });
          setSnackbarData({
            ...snackbarData,
            message: strings[pageTitle][language].success,
            show: true,
            severity: "success",
          });
        }

        setLoading(false);
      })
      .catch((e) => {
        console.log(e);
      });
    setLoading(false);
  }

  function deleteEntry() {
    let id = itemToDelete.phoneBookItemId;
    setLoading(true);
    api
      .deletePhoneBookItemById(id)
      .then((response) => {
        console.log(response);
        const newArray = phonebookItems.filter(
          (item) => item.phoneBookItemId !== id
        );
        setPhonebookItems(newArray);
        setLoading(false);
        setItemToDelete({});
        setModals({ ...modals, deleteModal: false });
        setSnackbarData({
          ...snackbarData,
          message: strings[pageTitle][language].deletedSuccess,
          show: true,
          severity: "success",
        });
      })
      .catch((e) => {
        console.log(e);
      });
  }

  function editEntry(e) {
    setLoading(true);
    e.preventDefault();
    console.log(editingEntryData);
    api
      .modifyPhoneBookItemById(
        editingEntryData.phoneBookItemId,
        editingEntryData
      )
      .then((response) => {
        console.log(response);
        setEditingEntryData({});
        api.getAllPhoneBookItems().then((response) => {
          setPhonebookItems(response.data.object);
          setModals({ ...modals, editModal: false });
          setLoading(false);
        });
        setSnackbarData({
          ...snackbarData,
          message: strings[pageTitle][language].editedSuccess,
          show: true,
          severity: "success",
        });
      })
      .catch((e) => {
        console.log(e);
      });
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    console.log(newEntryData);
    setNewEntryData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleInputChangeEdit = (e) => {
    const { name, value } = e.target;
    setEditingEntryData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  useEffect(() => {
    checkAuthorization("PHONE_BOOK").then((result) => {
      if (result) {
        setLoading(true);
        api
          .getAllPhoneBookItems()
          .then((response) => {
            //console.log(response);
            setPhonebookItems(response.data.object);
          })
          .catch((e) => {
            console.log(e);
          });

        api
          .getAllLobs()
          .then((response) => {
            setLinesOfBusiness(response.data.object);
          })
          .catch((e) => {
            console.log(e);
          });

        api
          .getAllOutboundVdns()
          .then((response) => {
            setOutboundLines(response.data.object);
            setLoading(false);
          })
          .catch((e) => {
            console.log(e);
          });
      } else {
        navigate("/unauthorized");
      }
    });
  }, []);

  return (
    <div className="main-content">
      <p className="main-content__title">
        {strings[pageTitle][language].pageName}
      </p>
      <hr className="main-content-title__hr" />

      <div
        style={{
          display: "flex",
          justifyContent: "end",
          flexDirection: "row",
        }}
      >
        <button
          className="btn btn-outline-primary"
          onClick={() => setModals({ ...modals, addModal: true })}
        >
          {strings[pageTitle][language].add}
        </button>
      </div>

      {isLoading ? (
        <Loading></Loading>
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: "row",
          }}
        >
          <Snackbar
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            open={snackbarData.show}
            autoHideDuration={3000}
            onClose={() => setSnackbarData({ ...snackbarData, show: false })}
          >
            <Alert severity={snackbarData.severity}>
              {snackbarData.message}
            </Alert>
          </Snackbar>
          <table
            style={{
              width: "100%",
              marginTop: 20,
              border: "none",
            }}
          >
            <thead>
              <tr align={"left"}>
                <th>{strings[pageTitle][language].name}</th>
                <th>{strings[pageTitle][language].telephoneNumber}</th>
                <th>{strings[pageTitle][language].outboundLine}</th>
                <th>{strings[pageTitle][language].lineOfBusiness}</th>
                <th>{strings[pageTitle][language].editDelete}</th>
              </tr>
            </thead>
            <tbody>
              {phonebookItems.map((item) => {
                return (
                  <tr key={item.phoneBookItemId}>
                    <td>{item.name}</td>
                    <td>{item.phone}</td>
                    <td>{item.outboundLineName}</td>
                    <td>{item.lineOfBusiness}</td>
                    <td>
                      <button
                        style={{
                          border: "none",
                          outline: "none",
                          backgroundColor: "rgba(255, 0, 0, 0)",
                          color: "#00a0e5",
                        }}
                        onClick={() => {
                          setEditingEntryData(item);
                          setModals({ ...modals, editModal: true });
                        }}
                      >
                        <EditIcon></EditIcon>
                      </button>
                      <button
                        onClick={() => {
                          setModals({ ...modals, deleteModal: true });
                          setItemToDelete(item);
                        }}
                        style={{
                          border: "none",
                          outline: "none",
                          backgroundColor: "rgba(255, 0, 0, 0)",
                          color: "#00a0e5",
                        }}
                      >
                        <DeleteIcon></DeleteIcon>
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      <Modal
        show={modals.addModal}
        onHide={() => setModals({ ...modals, addModal: false })}
      >
        <Form onSubmit={addNewEntry}>
          <Modal.Body>
            <b>{strings[pageTitle][language].addModal}</b>
            <Form.Group className="mb-3" controlId="name">
              <Form.Label>{strings[pageTitle][language].name}</Form.Label>
              <Form.Control
                placeholder=""
                autoFocus
                required
                type="text"
                defaultValue={newEntryData.name}
                onChange={handleInputChange}
                name="name"
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="phone">
              <Form.Label>
                {strings[pageTitle][language].telephoneNumber}
              </Form.Label>
              <Form.Control
                placeholder=""
                required
                type="text"
                defaultValue={newEntryData.phone}
                onChange={handleInputChange}
                name="phone"
                pattern="(^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$)|(^(\+|00)([1-9][0-9]|800|0800)[0-9 \-\(\)\.]{6,29}$)"
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="outboundLineName">
              <Form.Label>
                {strings[pageTitle][language].outboundLine}
              </Form.Label>
              <Form.Select
                defaultValue={newEntryData.outboundLineName}
                onChange={handleInputChange}
                name="outboundLineName"
              >
                <option> </option>
                {outboundLines.map((line) => {
                  return (
                    <option value={line.name} key={line.outboundVdnId}>
                      {line.name}
                    </option>
                  );
                })}
              </Form.Select>
            </Form.Group>
            <Form.Group className="mb-3" controlId="lineOfBusiness">
              <Form.Label>
                {strings[pageTitle][language].lineOfBusiness}
              </Form.Label>
              <Form.Select
                defaultValue={newEntryData.lineOfBusiness}
                onChange={handleInputChange}
                name="lineOfBusiness"
              >
                <option> </option>
                {linesOfBusiness.map((lob) => {
                  return (
                    <option value={lob.name} key={lob.id}>
                      {lob.name}
                    </option>
                  );
                })}
              </Form.Select>
            </Form.Group>
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="light"
              onClick={() => {
                setModals({ ...modals, addModal: false });
                setNewEntryData({
                  name: "",
                  phone: "",
                  lineOfBusiness: "",
                  outboundLineName: "",
                  position: 1,
                });
              }}
            >
              {strings[pageTitle][language].cancel}
            </Button>
            <Button variant="primary" type="submit">
              {strings[pageTitle][language].add}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      <Modal
        show={modals.editModal}
        onHide={() => setModals({ ...modals, editModal: false })}
      >
        <Form onSubmit={editEntry}>
          <Modal.Body>
            <b>{strings[pageTitle][language].editingModalTitle}</b>
            <Form.Group className="mb-3" controlId="name">
              <Form.Label>{strings[pageTitle][language].name}</Form.Label>
              <Form.Control
                placeholder=""
                autoFocus
                required
                type="text"
                defaultValue={editingEntryData.name}
                onChange={handleInputChangeEdit}
                name="name"
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="phone">
              <Form.Label>
                {strings[pageTitle][language].telephoneNumber}
              </Form.Label>
              <Form.Control
                placeholder=""
                required
                type="text"
                defaultValue={editingEntryData.phone}
                onChange={handleInputChangeEdit}
                name="phone"
                pattern="(^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$)|(^(\+|00)([1-9][0-9]|800|0800)[0-9 \-\(\)\.]{6,29}$)"
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="outboundLineName">
              <Form.Label>
                {strings[pageTitle][language].outboundLine}
              </Form.Label>
              <Form.Select
                defaultValue={editingEntryData.outboundLineName}
                onChange={handleInputChangeEdit}
                name="outboundLineName"
              >
                <option> </option>
                {outboundLines.map((line) => {
                  return (
                    <option value={line.name} key={line.outboundVdnId}>
                      {line.name}
                    </option>
                  );
                })}
              </Form.Select>
            </Form.Group>
            <Form.Group className="mb-3" controlId="lineOfBusiness">
              <Form.Label>
                {strings[pageTitle][language].lineOfBusiness}
              </Form.Label>
              <Form.Select
                defaultValue={editingEntryData.lineOfBusiness}
                onChange={handleInputChangeEdit}
                name="lineOfBusiness"
              >
                <option> </option>
                {linesOfBusiness.map((lob) => {
                  return (
                    <option value={lob.name} key={lob.id}>
                      {lob.name}
                    </option>
                  );
                })}
              </Form.Select>
            </Form.Group>
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="light"
              onClick={() => {
                setModals({ ...modals, editModal: false });
                setEditingEntryData({});
              }}
            >
              {strings[pageTitle][language].cancel}
            </Button>
            <Button variant="primary" type="submit">
              {strings[pageTitle][language].confirm}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      <Modal show={modals.deleteModal}>
        <Modal.Body>
          <p>{strings[pageTitle][language].deleteModalTitle}</p>
          <Modal.Footer>
            <Button
              variant="light"
              onClick={() => {
                setModals({ ...modals, deleteModal: false });
              }}
            >
              {strings[pageTitle][language].cancel}
            </Button>
            <Button variant="danger" onClick={deleteEntry}>
              {strings[pageTitle][language].confirm}
            </Button>
          </Modal.Footer>
        </Modal.Body>
      </Modal>
    </div>
  );
}
